import { render } from "./InviteFriends.vue?vue&type=template&id=a270897e&ts=true"
import script from "./InviteFriends.vue?vue&type=script&lang=ts"
export * from "./InviteFriends.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/www-root/data/www/brazilist-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__